import React from 'react';

export const TwoLinesIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="19"
    height="12"
    viewBox="0 0 19 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    { ...props }
  >
    <title>TwoLine</title>
    <rect width="13" height="4" rx="2" fill="#D9D9D9"/>
    <rect x="6" y="8" width="13" height="4" rx="2" fill="#D9D9D9"/>
  </svg>
);
